<template>
  <TagsViewer
    :editMode="true"
    :filterByTag="userEditObj.ingest_tags"
    :tags="Object.values(deluge.tags)"
    @select="add_tag_to_select"
    :selectable="true"
    :tagContainerHeight="true" />
</template>
<script setup>
import { defineProps } from 'vue';
import TagsViewer from '../../Shared/TagsViewer.vue';
import { deluge } from '../../../stores/deluge';

const props = defineProps(['userEditObj']);
function add_tag_to_select(newTag) {
  if (!props.userEditObj.ingest_tags.includes(newTag.uid)) {
    props.userEditObj.ingest_tags.push(newTag.uid);
  } else {
    props.userEditObj.ingest_tags = props.userEditObj.ingest_tags.filter(
      (tag) => tag !== newTag.uid
    );
  }
}
</script>

<style scoped></style>
